/**
 * The picker's two text rules.
 *
 * In their own file rather than beside the row components, because
 * react-refresh/only-export-components forbids exporting a value alongside a
 * component — the same reason drawColors.ts exists.
 */

function fmt(s: number): string {
  const m = Math.floor(s / 60);
  return `${m}:${Math.floor(s % 60).toString().padStart(2, '0')}`;
}

/**
 * A segment's time range, or what it is when there is no range.
 *
 * startTime === endTime is a freeze frame, not a zero-length clip, and
 * "0:00 – 0:00" reads as a broken row rather than as a still.
 */
export function rangeLabel(startTime: number, endTime: number): string {
  return startTime === endTime ? 'Freeze frame' : `${fmt(startTime)} – ${fmt(endTime)}`;
}

/**
 * Every row leads with a name. Segments are auto-named "Segment N" when
 * created, but the name is free text and can be cleared, so a row can arrive
 * with an empty label. Falling back to the position keeps the rule — a name,
 * never a time range — without inventing anything.
 */
export function rowName(label: string | undefined, index: number): string {
  return label?.trim() || `Part ${index + 1}`;
}
